const base = '/message'

export const messaging = {
    create_conversation: `${base}/conversation`,
    create_message: `${base}`,
    get_conversations: `${base}/conversations`,
    get_conversation: `${base}/`,
}